import { $lte as __lte, createExpressionOperator } from "../../_predicates";
const $lte = createExpressionOperator(__lte);
export {
  $lte
};
